<script>
import { get, edit, getAll, xls } from '@/api'
export default {
  mixins: [],
  components: {
  },
  computed: {
  },
  data: function () {
    return {
      items: {
      },

      refs: [
      ],

      loadingRefs: {},
    }
  },
  methods: {
    // references
    loadRefs (url, name) {
      this.loadingRefs[name] = true
      getAll(url).then((response) => {
        this.items[name] = response.data.results
        this.loadingRefs[name] = false
      }).catch((err) => {
        if (err.response.data && err.response.data.detail) {
          this.$notify({ group: 'main', title: 'Загрузка', text: `Ошибка справочника! . ${err.response.data.detail}`, type: 'warning' })
        } else {
          this.$notify({ group: 'main', title: 'Загрузка', text: 'Ошибка справочника!', type: 'error' })
        }
        this.loadingRefs[name] = false
      })
    },
  },
  mounted () {
  },
  created () {
    // references
    this.refs.forEach((entry) => {
      this.loadRefs(entry.url, entry.name)
    }, this)
  }
}
</script>
